import { memo, useMemo } from 'react'
import { PanelRoot } from '..'
import { SingleSheetPropertiesValidationErrors } from '../hooks/formValidation'
import { CellFacade, TableRow } from './cells'
import { TableHeader } from './Header'
import { BasicInformatioTableDef, CellDef } from './model'
import { FormModelModifiers } from '../model/formModelModifiers'
import { EditedFormData } from '../hooks/editedFormData'

export const TablePanel = () => {
  return <PanelRoot></PanelRoot>
}

type BasicInformationTableProps = {
  dataUuid: string
  tableDef: BasicInformatioTableDef
  formModel: object
  formModelModifiers: FormModelModifiers
  editedFormData: EditedFormData
  validationErrors: SingleSheetPropertiesValidationErrors
}
export const BasicInformationTable = ({
  dataUuid,
  tableDef,
  formModel,
  formModelModifiers,
  editedFormData,
  validationErrors,
}: BasicInformationTableProps) => {
  return (
    <>
      {tableDef.tables.map(({ header, rows }) => (
        <>
          <TableHeader key={header.externalId} title={header.label} />
          {rows.map(cells => (
            <TableRow
              key={`${header.externalId}-${cells
                .map(v => v.externalId)
                .join('-')}`}
            >
              {cells.map(cell => (
                <Cell
                  key={cell.field}
                  dataUuid={dataUuid}
                  cellDef={cell}
                  formModel={formModel}
                  formModelModifiers={formModelModifiers}
                  editedFormData={editedFormData}
                  validationErrors={validationErrors}
                />
              ))}
            </TableRow>
          ))}
        </>
      ))}
    </>
  )
}

const Cell = memo(
  ({
    dataUuid,
    cellDef,
    formModel,
    formModelModifiers,
    editedFormData,
    validationErrors,
  }: {
    dataUuid: string
    cellDef: CellDef
    formModel: object
    formModelModifiers: FormModelModifiers
    editedFormData: EditedFormData
    validationErrors: SingleSheetPropertiesValidationErrors
  }) => {
    const value = useMemo(
      () =>
        cellDef.getValue
          ? cellDef.getValue(formModel)
          : formModel[cellDef.field],
      [cellDef, formModel]
    )
    const modifier = useMemo(
      () => formModelModifiers[cellDef.field],
      [formModelModifiers, cellDef.field]
    )
    const edited = useMemo(
      () => editedFormData[cellDef.field],
      [editedFormData, cellDef.field]
    )
    const validationErrorsOfThisCell = useMemo(
      () => validationErrors[cellDef.field],
      [validationErrors, cellDef.field]
    )

    return (
      <CellFacade
        key={cellDef.field}
        dataUuid={dataUuid}
        cellDef={cellDef}
        value={value}
        onChange={modifier}
        edited={edited}
        validationErrors={validationErrorsOfThisCell}
      />
    )
  }
)
